import React from "react";

const DetailsIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="36.563"
      viewBox="0 0 45 36.563"
    >
      <path
        id="db22"
        d="M49,7.406A1.405,1.405,0,0,0,47.594,6H30.719a1.406,1.406,0,0,0,0,2.813H47.594A1.405,1.405,0,0,0,49,7.406Zm0,8.437a1.405,1.405,0,0,0-1.406-1.406H30.719a1.406,1.406,0,0,0,0,2.813H47.594A1.405,1.405,0,0,0,49,15.844Zm0,8.438a1.405,1.405,0,0,0-1.406-1.406H30.719a1.406,1.406,0,0,0,0,2.813H47.594A1.405,1.405,0,0,0,49,24.281Zm0,8.437a1.405,1.405,0,0,0-1.406-1.406H5.406a1.406,1.406,0,0,0,0,2.813H47.594A1.405,1.405,0,0,0,49,32.719Zm0,8.438a1.405,1.405,0,0,0-1.406-1.406H5.406a1.406,1.406,0,0,0,0,2.813H47.594A1.405,1.405,0,0,0,49,41.156ZM20.875,25.688H6.813A2.813,2.813,0,0,1,4,22.875V8.813A2.813,2.813,0,0,1,6.813,6H20.875a2.813,2.813,0,0,1,2.813,2.813V22.875A2.813,2.813,0,0,1,20.875,25.688Z"
        transform="translate(-4 -6)"
        fill={fill ? fill : "#43e57a"}
      />
    </svg>
  );
};

export default DetailsIcon;
